import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicNav from '../components/dna/PublicNav';
import Footer from '../components/dna/Footer';

const TermsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    { id: 'preambule', title: 'Préambule' },
    { id: 'definitions', title: '1. Définitions' },
    { id: 'acces', title: '2. Accès à la plateforme' },
    { id: 'inscription', title: '3. Inscription et comptes' },
    { id: 'artistes', title: '4. Conditions Artistes' },
    { id: 'fans', title: '5. Conditions Fans' },
    { id: 'paiements', title: '6. Paiements et commissions' },
    { id: 'passcode', title: '7. Système Pass\'Code' },
    { id: 'propriete', title: '8. Propriété intellectuelle' },
    { id: 'donnees', title: '9. Protection des données' },
    { id: 'responsabilites', title: '10. Responsabilités' },
    { id: 'suspension', title: '11. Suspension et résiliation' },
    { id: 'modifications', title: '12. Modifications des CGU' },
    { id: 'juridique', title: '13. Cadre juridique' },
    { id: 'annexe', title: 'Annexe' },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
    }
  };

  return (
    <div className="site-shell legal-page"><PublicNav /><div className="passio-terms-page">
      {/* Header */}
      <header className="passio-terms-header">
        <div className="passio-terms-header-inner">
          <Link to="/" className="passio-terms-logo">
            <img src="/assets/Logo.png" alt="Pass'io" />
          </Link>
          <nav className="passio-terms-nav">
            <Link to="/register" className="passio-terms-back">
              <i className="fas fa-arrow-left" /> Retour à l'inscription
            </Link>
          </nav>
        </div>
      </header>

      <div className="passio-terms-container">
        {/* Sidebar Navigation */}
        <aside className="passio-terms-sidebar">
          <div className="passio-terms-sidebar-inner">
            <h3 className="passio-terms-sidebar-title">Sommaire</h3>
            <nav className="passio-terms-toc">
              {sections.map((section) => (
                <button
                  key={section.id}
                  onClick={() => scrollToSection(section.id)}
                  className="passio-terms-toc-link"
                >
                  {section.title}
                </button>
              ))}
            </nav>
          </div>
        </aside>

        {/* Main Content */}
        <main className="passio-terms-content">
          {/* Hero */}
          <div className="passio-terms-hero">
            <span className="passio-terms-badge">Version 1.0</span>
            <h1 className="passio-terms-title">Conditions Générales d'Utilisation</h1>
            <p className="passio-terms-meta">
              <strong>Date d'entrée en vigueur :</strong> 1er Mai 2026
            </p>
            <p className="passio-terms-meta">
              <strong>Éditeur :</strong> Pass'io, Antananarivo, Madagascar
            </p>
            <p className="passio-terms-meta">
              <strong>Contact :</strong>{' '}
              <a href="mailto:contact@passio.mg">contact@passio.mg</a>
            </p>
          </div>

          {/* Préambule */}
          <section id="preambule" className="passio-terms-section">
            <h2>Préambule</h2>
            <p>
              Les présentes Conditions Générales d'Utilisation (ci-après « CGU ») régissent 
              l'accès et l'utilisation de la plateforme Pass'io, accessible via le site web 
              et l'application mobile du même nom.
            </p>
            <p>
              Pass'io est une plateforme de distribution musicale numérique permettant aux 
              artistes de vendre leurs œuvres et aux fans d'en faire l'acquisition, via les 
              systèmes de paiement Mobile Money disponibles à Madagascar (MVola, Orange Money).
            </p>
            <div className="passio-terms-notice">
              <i className="fas fa-info-circle" />
              <p>
                <strong>Important :</strong> Toute inscription ou utilisation de la plateforme 
                vaut acceptation pleine et entière des présentes CGU. Si vous n'acceptez pas 
                ces conditions, vous êtes invité(e) à ne pas utiliser la plateforme.
              </p>
            </div>
          </section>

          {/* 1. Définitions */}
          <section id="definitions" className="passio-terms-section">
            <h2>1. Définitions</h2>
            <p>Dans les présentes CGU, les termes suivants ont la signification indiquée ci-dessous :</p>
            <div className="passio-terms-table-wrapper">
              <table className="passio-terms-table">
                <thead>
                  <tr>
                    <th>Terme</th>
                    <th>Définition</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>Pass'io</strong></td>
                    <td>La société éditrice de la plateforme, ses services associés et son équipe</td>
                  </tr>
                  <tr>
                    <td><strong>Plateforme</strong></td>
                    <td>L'ensemble des services numériques Pass'io : site web, application mobile, bot Telegram, dashboard artiste</td>
                  </tr>
                  <tr>
                    <td><strong>Artiste</strong></td>
                    <td>Toute personne physique ou morale inscrite sur la plateforme dans le but de distribuer et vendre ses œuvres musicales</td>
                  </tr>
                  <tr>
                    <td><strong>Fan</strong></td>
                    <td>Toute personne utilisant la plateforme pour découvrir et acheter de la musique</td>
                  </tr>
                  <tr>
                    <td><strong>Utilisateur</strong></td>
                    <td>Désigne indifféremment tout Artiste ou Fan utilisant la plateforme</td>
                  </tr>
                  <tr>
                    <td><strong>Pass'Code</strong></td>
                    <td>Code alphanumérique unique de 8 caractères généré après validation d'un paiement, permettant l'accès à un album acheté</td>
                  </tr>
                  <tr>
                    <td><strong>Album</strong></td>
                    <td>Toute œuvre musicale mise en vente sur la plateforme, qu'il s'agisse d'un single, d'un EP ou d'un album complet</td>
                  </tr>
                  <tr>
                    <td><strong>Mobile Money</strong></td>
                    <td>Les services de paiement mobile disponibles à Madagascar, notamment MVola et Orange Money</td>
                  </tr>
                  <tr>
                    <td><strong>Commission</strong></td>
                    <td>La part retenue par Pass'io sur chaque transaction effectuée sur la plateforme</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* 2. Accès à la plateforme */}
          <section id="acces" className="passio-terms-section">
            <h2>2. Accès à la plateforme</h2>
            
            <h3>2.1 Disponibilité</h3>
            <p>
              Pass'io s'engage à mettre tout en œuvre pour assurer la disponibilité de la 
              plateforme 24h/24 et 7j/7. Cependant, des interruptions peuvent survenir pour 
              des raisons de maintenance, de mise à jour technique ou de force majeure. Pass'io 
              ne saurait être tenu responsable de toute interruption de service indépendante de sa volonté.
            </p>

            <h3>2.2 Conditions d'accès</h3>
            <p>L'accès à la plateforme est ouvert à toute personne :</p>
            <ul>
              <li>Résidant à Madagascar ou disposant d'un accès à internet</li>
              <li>Âgée de 18 ans minimum, ou de 13 ans minimum avec l'accord parental pour la consultation des previews gratuites</li>
              <li>Disposant d'un numéro de téléphone valide pour les opérations impliquant un paiement</li>
            </ul>

            <h3>2.3 Équipements</h3>
            <p>
              L'Utilisateur est seul responsable de disposer des équipements nécessaires 
              (téléphone, connexion internet, compte Mobile Money actif) pour accéder à la 
              plateforme et utiliser ses services.
            </p>
          </section>

          {/* 3. Inscription et comptes */}
          <section id="inscription" className="passio-terms-section">
            <h2>3. Inscription et comptes utilisateurs</h2>
            
            <h3>3.1 Création de compte Artiste</h3>
            <p>
              L'inscription en tant qu'Artiste est soumise à une vérification d'identité 
              effectuée par l'équipe Pass'io. L'Artiste s'engage à fournir des informations 
              exactes, complètes et à jour, notamment :
            </p>
            <ul>
              <li>Son identité réelle (nom et prénom)</li>
              <li>Un numéro de téléphone valide</li>
              <li>Un numéro Mobile Money actif pour la réception des paiements</li>
            </ul>
            <p><strong>Toute fausse déclaration entraîne la suspension immédiate du compte.</strong></p>

            <h3>3.2 Sécurité du compte</h3>
            <p>
              L'Utilisateur est seul responsable de la confidentialité de ses identifiants de 
              connexion. Toute utilisation du compte effectuée via ses identifiants est réputée 
              avoir été réalisée par l'Utilisateur lui-même. En cas de suspicion de compromission 
              du compte, l'Utilisateur doit en informer Pass'io sans délai à{' '}
              <a href="mailto:contact@passio.mg">contact@passio.mg</a>.
            </p>

            <h3>3.3 Unicité du compte</h3>
            <p>
              Un Artiste ne peut posséder qu'un seul compte sur la plateforme. La création de 
              comptes multiples est strictement interdite et entraîne la suspension de l'ensemble 
              des comptes concernés.
            </p>
          </section>

          {/* 4. Conditions Artistes */}
          <section id="artistes" className="passio-terms-section">
            <h2>4. Conditions spécifiques aux Artistes</h2>
            
            <h3>4.1 Mise en ligne des œuvres</h3>
            <p>
              L'Artiste est seul responsable du contenu qu'il met en ligne. En déposant une 
              œuvre sur la plateforme, l'Artiste déclare et garantit :
            </p>
            <ul>
              <li>Être le titulaire des droits de propriété intellectuelle sur l'œuvre, ou avoir obtenu toutes les autorisations nécessaires des ayants droit</li>
              <li>Que l'œuvre ne porte pas atteinte aux droits d'un tiers (droits d'auteur, droits voisins, droits à l'image)</li>
              <li>Que l'œuvre ne contient aucun contenu illégal, diffamatoire, injurieux, obscène ou incitant à la haine ou à la violence</li>
              <li>Que les fichiers fournis respectent les standards de qualité minimaux requis (audio : minimum 128 kbps, formats MP3 ou WAV)</li>
            </ul>

            <h3>4.2 Licence accordée à Pass'io</h3>
            <p>
              En mettant une œuvre en ligne, l'Artiste accorde à Pass'io une{' '}
              <strong>licence non-exclusive, non-cessible et révocable</strong> lui permettant de :
            </p>
            <ul>
              <li>Distribuer et commercialiser l'œuvre sur la plateforme Pass'io</li>
              <li>Générer automatiquement des extraits de 30 secondes à des fins de promotion</li>
              <li>Héberger les fichiers sur ses serveurs sécurisés (Cloudinary)</li>
              <li>Utiliser le titre et la pochette de l'album à des fins de promotion de la plateforme</li>
            </ul>
            <p>
              Cette licence est limitée au territoire malgache et prend fin automatiquement en 
              cas de retrait de l'œuvre par l'Artiste ou de résiliation du compte.
            </p>

            <h3>4.3 Non-exclusivité</h3>
            <p>
              Pass'io ne revendique <strong>aucune exclusivité</strong> sur la distribution des œuvres. 
              L'Artiste reste libre de distribuer ses œuvres sur toute autre plateforme 
              simultanément, sans obligation d'en informer Pass'io.
            </p>

            <h3>4.4 Fixation des prix</h3>
            <p>
              L'Artiste fixe librement le prix de vente de ses œuvres en Ariary malgache (Ar). 
              Pass'io ne fixe aucun prix minimum ni maximum. L'Artiste peut modifier le prix de 
              vente d'un album à tout moment depuis son dashboard. Les modifications de prix 
              n'affectent pas les Pass'Codes déjà émis.
            </p>

            <h3>4.5 Obligations de l'Artiste</h3>
            <p>L'Artiste s'engage à :</p>
            <ul>
              <li>Maintenir ses coordonnées Mobile Money à jour pour permettre la réception des paiements</li>
              <li>Ne pas tenter de contourner les systèmes de protection, de paiement ou de vérification de la plateforme</li>
              <li>Signaler à Pass'io toute erreur ou anomalie constatée sur son compte ou ses statistiques</li>
              <li>Ne pas utiliser la plateforme à des fins frauduleuses ou contraires à la loi malgache</li>
            </ul>
          </section>

          {/* 5. Conditions Fans */}
          <section id="fans" className="passio-terms-section">
            <h2>5. Conditions spécifiques aux Fans</h2>
            
            <h3>5.1 Achat d'un album</h3>
            <p>
              L'achat d'un album par un Fan est définitif dès la validation du paiement Mobile 
              Money par le système Pass'io. Le Fan reçoit en contrepartie un Pass'Code unique 
              lui donnant accès à l'album acheté via l'application mobile Pass'io.
            </p>

            <h3>5.2 Droit d'usage</h3>
            <p>
              L'achat d'un album confère au Fan un{' '}
              <strong>droit d'usage personnel, non-exclusif et non-transférable</strong> sur 
              l'œuvre. Ce droit permet exclusivement :
            </p>
            <ul>
              <li>L'écoute de l'œuvre via l'application mobile Pass'io sur l'appareil sur lequel le Pass'Code a été activé</li>
              <li>L'écoute en mode hors-ligne sur ce même appareil</li>
            </ul>
            <p>Toute autre utilisation est strictement interdite, notamment :</p>
            <ul>
              <li>La copie, la reproduction ou la redistribution des fichiers audio</li>
              <li>Le partage du Pass'Code avec des tiers</li>
              <li>L'extraction ou la conversion des fichiers audio</li>
              <li>L'utilisation commerciale de l'œuvre</li>
            </ul>

            <h3>5.3 Politique de remboursement</h3>
            <p>
              En raison de la nature numérique des produits, <strong>aucun remboursement n'est 
              accordé</strong> après activation du Pass'Code. En cas de problème technique avéré 
              (Pass'Code invalide non lié à une activation préalable), le Fan peut contacter le 
              support Pass'io à{' '}
              <a href="mailto:contact@passio.mg">contact@passio.mg</a> dans un délai de 7 jours suivant l'achat.
            </p>

            <h3>5.4 Perte ou changement d'appareil</h3>
            <p>
              Le Pass'Code étant lié à l'identifiant physique de l'appareil lors de sa première 
              activation, en cas de perte, vol ou changement de téléphone, le Fan peut soumettre 
              une demande de réactivation auprès du support Pass'io. Cette réactivation est 
              soumise à vérification de l'historique d'achat et n'est accordée qu'une seule fois 
              par Pass'Code.
            </p>
          </section>

          {/* 6. Paiements */}
          <section id="paiements" className="passio-terms-section">
            <h2>6. Paiements et commissions</h2>
            
            <h3>6.1 Système de paiement</h3>
            <p>
              Les paiements s'effectuent exclusivement via les systèmes Mobile Money disponibles 
              à Madagascar (MVola, Orange Money). Pass'io n'accepte aucun autre mode de paiement 
              dans la version actuelle de la plateforme.
            </p>

            <h3>6.2 Commission Pass'io</h3>
            <p>Pour chaque vente réalisée sur la plateforme, Pass'io retient une commission selon le barème suivant :</p>
            <div className="passio-terms-table-wrapper">
              <table className="passio-terms-table">
                <thead>
                  <tr>
                    <th>Type de vente</th>
                    <th className="text-center">Part Artiste</th>
                    <th className="text-center">Commission Pass'io</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Album numérique</td>
                    <td className="text-center"><strong className="passio-terms-highlight">80 %</strong></td>
                    <td className="text-center">20 %</td>
                  </tr>
                  <tr>
                    <td>Merchandising (Phase 2)</td>
                    <td className="text-center"><strong className="passio-terms-highlight">75 %</strong></td>
                    <td className="text-center">25 %</td>
                  </tr>
                  <tr>
                    <td>Billetterie (Phase 3)</td>
                    <td className="text-center"><strong className="passio-terms-highlight">90 %</strong></td>
                    <td className="text-center">10 %</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p>La commission de Pass'io couvre les frais d'infrastructure, de développement, de sécurité et de traitement des paiements.</p>

            <h3>6.3 Versement des gains</h3>
            <p>Les gains de l'Artiste sont crédités sur son compte Pass'io en temps réel après chaque vente validée. Le versement sur le Mobile Money de l'Artiste est soumis aux conditions suivantes :</p>
            <ul>
              <li><strong>Montant minimum de retrait :</strong> 5 000 Ar</li>
              <li><strong>Délai de traitement :</strong> 24 à 72 heures ouvrables à compter de la demande</li>
              <li><strong>Moyen de versement :</strong> exclusivement vers le numéro Mobile Money enregistré sur le compte Artiste</li>
            </ul>
            <p>
              Pass'io se réserve le droit de suspendre un versement en cas de suspicion de fraude, 
              le temps de procéder aux vérifications nécessaires. L'Artiste en est informé sans délai.
            </p>

            <h3>6.4 Abonnement Artiste Pro</h3>
            <p>
              L'offre Pro est proposée au tarif de <strong>15 000 Ar par mois</strong>. Elle est 
              renouvelée automatiquement chaque mois sauf résiliation de l'Artiste. Pass'io 
              informera l'Artiste de tout changement tarifaire avec un préavis minimum de{' '}
              <strong>30 jours calendaires</strong>.
            </p>
          </section>

          {/* 7. Pass'Code */}
          <section id="passcode" className="passio-terms-section">
            <h2>7. Système Pass'Code</h2>
            
            <h3>7.1 Génération</h3>
            <p>
              Un Pass'Code est généré automatiquement par le système Pass'io après validation 
              du paiement Mobile Money du Fan. Chaque Pass'Code est unique et correspond à un seul album.
            </p>

            <h3>7.2 Activation et verrouillage</h3>
            <p>
              Lors de sa première saisie dans l'application mobile Pass'io, le Pass'Code est 
              définitivement lié à l'identifiant unique de l'appareil (Device ID). Cette opération 
              est <strong>irréversible</strong>. Un Pass'Code activé ne peut plus être utilisé 
              sur un autre appareil, sauf dans le cas exceptionnel prévu à l'article 5.4.
            </p>

            <h3>7.3 Protection technique</h3>
            <p>Les fichiers audio associés à un Pass'Code sont :</p>
            <ul>
              <li>Stockés de manière chiffrée sur l'appareil de l'utilisateur</li>
              <li>Déchiffrés uniquement en mémoire vive (RAM) lors de la lecture</li>
              <li>Inaccessibles depuis les gestionnaires de fichiers du téléphone</li>
            </ul>
            <p>
              Pass'io met tout en œuvre pour maintenir ces protections techniques mais ne peut 
              garantir une protection absolue contre toute tentative de contournement sophistiquée.
            </p>
          </section>

          {/* 8. Propriété intellectuelle */}
          <section id="propriete" className="passio-terms-section">
            <h2>8. Propriété intellectuelle</h2>
            
            <h3>8.1 Droits des Artistes</h3>
            <p>
              Les Artistes conservent l'intégralité de leurs droits de propriété intellectuelle 
              sur leurs œuvres. Pass'io ne revendique aucun droit de propriété sur les contenus 
              mis en ligne. La licence accordée à Pass'io (article 4.2) ne constitue en aucun 
              cas un transfert de propriété.
            </p>

            <h3>8.2 Droits de Pass'io</h3>
            <p>
              La plateforme Pass'io, son code source, son design, ses marques, logos et toute 
              autre propriété intellectuelle appartenant à Pass'io sont protégés et ne peuvent 
              être reproduits, copiés ou utilisés sans autorisation écrite préalable.
            </p>

            <h3>8.3 Signalement de violation</h3>
            <p>
              Tout Artiste constatant une violation de ses droits de propriété intellectuelle 
              sur la plateforme est invité à le signaler à{' '}
              <a href="mailto:contact@passio.mg">contact@passio.mg</a>. Pass'io s'engage 
              à traiter toute réclamation fondée dans un délai de 7 jours ouvrables.
            </p>
          </section>

          {/* 9. Protection des données */}
          <section id="donnees" className="passio-terms-section">
            <h2>9. Protection des données personnelles</h2>
            
            <h3>9.1 Données collectées</h3>
            <p>Dans le cadre de son activité, Pass'io collecte les données suivantes :</p>
            <ul>
              <li><strong>Artistes :</strong> nom, prénom, numéro de téléphone, numéro Mobile Money, statistiques de ventes</li>
              <li><strong>Fans :</strong> numéro de téléphone (lié au paiement Mobile Money), historique d'achats, identifiant de l'appareil (Device ID)</li>
            </ul>

            <h3>9.2 Finalités du traitement</h3>
            <p>Les données sont collectées et traitées pour les finalités suivantes :</p>
            <ul>
              <li>Gestion des comptes utilisateurs et authentification</li>
              <li>Traitement des paiements et versement des gains</li>
              <li>Lutte contre la fraude et protection des œuvres</li>
              <li>Statistiques d'utilisation de la plateforme</li>
              <li>Communication liée aux ventes (notifications Telegram)</li>
            </ul>

            <h3>9.3 Conservation des données</h3>
            <p>
              Les données sont conservées pendant toute la durée de l'utilisation de la 
              plateforme, puis pendant une durée de <strong>3 ans</strong> après la clôture 
              du compte, conformément aux obligations légales en vigueur.
            </p>

            <h3>9.4 Droits des Utilisateurs</h3>
            <p>
              Conformément à la législation malgache applicable, tout Utilisateur dispose d'un 
              droit d'accès, de rectification et de suppression de ses données personnelles. 
              Ces droits peuvent être exercés en contactant Pass'io à{' '}
              <a href="mailto:contact@passio.mg">contact@passio.mg</a>.
            </p>

            <h3>9.5 Sécurité</h3>
            <p>
              Pass'io met en œuvre des mesures techniques et organisationnelles appropriées 
              pour protéger les données personnelles contre tout accès non autorisé, perte ou divulgation.
            </p>
          </section>

          {/* 10. Responsabilités */}
          <section id="responsabilites" className="passio-terms-section">
            <h2>10. Responsabilités et limitations</h2>
            
            <h3>10.1 Responsabilité de l'Artiste</h3>
            <p>L'Artiste est seul responsable :</p>
            <ul>
              <li>Du contenu mis en ligne et de la légalité de celui-ci</li>
              <li>De la détention des droits sur les œuvres distribuées</li>
              <li>Des informations communiquées à Pass'io (identité, coordonnées bancaires)</li>
              <li>De toute réclamation d'un tiers liée à une violation de ses droits</li>
            </ul>

            <h3>10.2 Responsabilité de Pass'io</h3>
            <p>
              Pass'io est responsable du bon fonctionnement de la plateforme et du traitement 
              correct des transactions. Pass'io ne saurait être tenu responsable :
            </p>
            <ul>
              <li>Des pertes de revenus liées à une indisponibilité temporaire de la plateforme</li>
              <li>Du contenu mis en ligne par les Artistes</li>
              <li>Des litiges entre Artistes et Fans relatifs à la qualité des œuvres</li>
              <li>De tout dommage indirect ou imprévisible lié à l'utilisation de la plateforme</li>
              <li>Des dysfonctionnements des réseaux Mobile Money (MVola, Orange Money) indépendants de sa volonté</li>
            </ul>

            <h3>10.3 Force majeure</h3>
            <p>
              Pass'io ne peut être tenu responsable d'un manquement à ses obligations en cas 
              de force majeure, entendue comme tout événement imprévisible, irrésistible et 
              extérieur, notamment : catastrophes naturelles, pannes d'infrastructure nationale, 
              troubles sociaux, décisions gouvernementales.
            </p>
          </section>

          {/* 11. Suspension */}
          <section id="suspension" className="passio-terms-section">
            <h2>11. Suspension et résiliation</h2>
            
            <h3>11.1 Résiliation à l'initiative de l'Artiste</h3>
            <p>
              L'Artiste peut résilier son compte à tout moment en contactant Pass'io à{' '}
              <a href="mailto:contact@passio.mg">contact@passio.mg</a> ou via son dashboard. 
              La résiliation entraîne :
            </p>
            <ul>
              <li>Le retrait de l'ensemble des œuvres de la vente sur la plateforme</li>
              <li>Le versement des gains accumulés non retirés dans un délai de 72 heures ouvrables</li>
              <li>La conservation de l'accès aux albums pour les Fans ayant déjà activé leurs Pass'Codes</li>
            </ul>

            <h3>11.2 Suspension ou résiliation par Pass'io</h3>
            <p>Pass'io se réserve le droit de suspendre ou résilier un compte dans les cas suivants :</p>
            <ul>
              <li>Violation grave ou répétée des présentes CGU</li>
              <li>Mise en ligne de contenu illégal ou portant atteinte aux droits d'un tiers</li>
              <li>Tentative de fraude ou de contournement des systèmes de la plateforme</li>
              <li>Fausse déclaration d'identité ou de droits sur les œuvres</li>
            </ul>
            <p>
              Toute suspension est précédée d'une <strong>notification préalable par email</strong>, 
              sauf en cas d'urgence légale avérée. L'Artiste dispose d'un délai de{' '}
              <strong>7 jours calendaires</strong> pour répondre et régulariser sa situation 
              avant toute résiliation définitive.
            </p>
            <p>
              En cas de résiliation par Pass'io pour manquement grave, les gains accumulés 
              peuvent être retenus dans l'attente de la résolution des litiges éventuels.
            </p>
          </section>

          {/* 12. Modifications */}
          <section id="modifications" className="passio-terms-section">
            <h2>12. Modifications des CGU</h2>
            <p>
              Pass'io se réserve le droit de modifier les présentes CGU à tout moment. Les 
              modifications entrent en vigueur dès leur publication sur la plateforme. Les 
              Utilisateurs sont informés de toute modification substantielle par email ou 
              notification dans l'application, avec un préavis minimum de{' '}
              <strong>30 jours calendaires</strong>.
            </p>
            <p>
              L'utilisation continue de la plateforme après notification des modifications 
              vaut acceptation des nouvelles CGU. En cas de désaccord, l'Utilisateur est 
              libre de résilier son compte conformément à l'article 11.1.
            </p>
          </section>

          {/* 13. Juridique */}
          <section id="juridique" className="passio-terms-section">
            <h2>13. Cadre juridique et litiges</h2>
            
            <h3>13.1 Droit applicable</h3>
            <p>Les présentes CGU sont soumises au droit malgache, notamment :</p>
            <div className="passio-terms-table-wrapper">
              <table className="passio-terms-table">
                <thead>
                  <tr>
                    <th>Texte juridique</th>
                    <th>Objet</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>Loi n°2003-044</strong> du 28 juillet 2004</td>
                    <td>Code de la Propriété Intellectuelle de Madagascar — protection des droits d'auteur</td>
                  </tr>
                  <tr>
                    <td><strong>Loi n°2014-006</strong> du 19 juin 2014</td>
                    <td>Lutte contre la cybercriminalité — protection contre le piratage numérique</td>
                  </tr>
                  <tr>
                    <td><strong>Loi n°2014-014</strong></td>
                    <td>Transactions électroniques à Madagascar — encadrement des paiements mobiles</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3>13.2 Résolution amiable</h3>
            <p>
              En cas de litige entre un Utilisateur et Pass'io, les parties s'engagent à 
              rechercher en priorité une solution amiable. L'Utilisateur adresse sa réclamation 
              à <a href="mailto:contact@passio.mg">contact@passio.mg</a>. Pass'io s'engage 
              à y apporter une réponse dans un délai de <strong>14 jours calendaires</strong>.
            </p>

            <h3>13.3 Juridiction compétente</h3>
            <p>
              À défaut de résolution amiable, tout litige relatif à l'interprétation ou à 
              l'exécution des présentes CGU sera soumis à la compétence exclusive des{' '}
              <strong>tribunaux compétents d'Antananarivo</strong>, Madagascar.
            </p>
          </section>

          {/* Annexe */}
          <section id="annexe" className="passio-terms-section">
            <h2>Annexe — Récapitulatif des délais et seuils clés</h2>
            <div className="passio-terms-table-wrapper">
              <table className="passio-terms-table">
                <thead>
                  <tr>
                    <th>Élément</th>
                    <th>Valeur</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Délai de traitement des retraits</td>
                    <td><strong>24 à 72 heures ouvrables</strong></td>
                  </tr>
                  <tr>
                    <td>Montant minimum de retrait</td>
                    <td><strong>5 000 Ar</strong></td>
                  </tr>
                  <tr>
                    <td>Commission sur ventes d'albums</td>
                    <td><strong>20 %</strong></td>
                  </tr>
                  <tr>
                    <td>Abonnement Artiste Pro</td>
                    <td><strong>15 000 Ar / mois</strong></td>
                  </tr>
                  <tr>
                    <td>Préavis de modification des CGU</td>
                    <td><strong>30 jours calendaires</strong></td>
                  </tr>
                  <tr>
                    <td>Préavis de modification tarifaire</td>
                    <td><strong>30 jours calendaires</strong></td>
                  </tr>
                  <tr>
                    <td>Délai de réponse aux réclamations</td>
                    <td><strong>14 jours calendaires</strong></td>
                  </tr>
                  <tr>
                    <td>Délai de régularisation avant résiliation</td>
                    <td><strong>7 jours calendaires</strong></td>
                  </tr>
                  <tr>
                    <td>Conservation des données après clôture</td>
                    <td><strong>3 ans</strong></td>
                  </tr>
                  <tr>
                    <td>Délai de signalement pour Pass'Code invalide</td>
                    <td><strong>7 jours après achat</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* Footer */}
          <footer className="passio-terms-footer">
            <p>
              Pass'io — Conditions Générales d'Utilisation — Version 1.0 — Entrée en vigueur le 1er Mai 2026
            </p>
            <p>
              Document susceptible d'être mis à jour. La version en vigueur est toujours disponible sur{' '}
              <a href="https://artist.passio.mg">artist.passio.mg</a>
            </p>
            <p>Contact : contact@passio.mg — Antananarivo, Madagascar</p>
          </footer>
        </main>
      </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsPage;
